import { useState, useEffect } from "react";
import "@/App.css";
import { 
  Phone, 
  Menu, 
  X, 
  Truck, 
  Car, 
  Bike, 
  Fuel, 
  Wrench, 
  Battery, 
  CircleDot, 
  Shield, 
  Clock, 
  MapPin,
  MessageCircle,
  Send,
  ChevronRight,
  ChevronLeft
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent } from "@/components/ui/card";
import { 
  Carousel, 
  CarouselContent, 
  CarouselItem, 
  CarouselPrevious, 
  CarouselNext 
} from "@/components/ui/carousel";

// Business Info
const BUSINESS = {
  name: "Guincho Xavier",
  whatsapp: "(15) 99795-5461",
  whatsappNumber: "5515997955461",
  location: "Sorocaba e Região",
  tagline: "Auto Socorro 24h"
};

// Images - Real photos from Guincho Xavier
const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/ce5ngkqe_caminh%C3%A3o%20atras.jpeg",
  about: "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/i9zpmbqe_van%20branca%20em%20cima.jpeg",
  gallery: [
    // 3 imagens principais
    "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/zmhu2mhn_caminh%C3%A3o%20atras.jpeg",
    "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/88wgnu6o_WhatsApp%20Image%202026-03-11%20at%2018.18.18.jpeg",
    "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/kagg9y6e_WhatsApp%20Image%202026-03-11%20at%2018.18.33.jpeg",
    // Demais fotos
    "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/kjtlpvzo_WhatsApp%20Image%202026-02-19%20at%2008.12.56%20%282%29.jpeg",
    "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/aa779ubu_WhatsApp%20Image%202026-02-19%20at%2008.12.56.jpeg",
    "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/eqbi9zs3_WhatsApp%20Image%202026-02-19%20at%2008.12.51.jpeg",
    "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/ce5ngkqe_caminh%C3%A3o%20atras.jpeg",
    "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/i9zpmbqe_van%20branca%20em%20cima.jpeg",
    "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/3qiyqgku_WhatsApp%20Image%202026-02-19%20at%2008.12.57%20%281%29.jpeg",
    "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/jt5n70w0_WhatsApp%20Image%202026-02-19%20at%2008.12.57.jpeg",
    "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/06rskkmk_WhatsApp%20Image%202026-02-19%20at%2008.12.56%20%283%29.jpeg",
    "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/tvhaf2oo_WhatsApp%20Image%202026-02-19%20at%2008.12.50%20%282%29.jpeg",
    "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/8neuu6bj_WhatsApp%20Image%202026-02-19%20at%2008.12.50%20%281%29.jpeg",
    "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/k2z9t6qd_WhatsApp%20Image%202026-02-19%20at%2008.12.50.jpeg",
    "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/ltf09lqt_WhatsApp%20Image%202026-02-19%20at%2008.12.51%20%281%29.jpeg",
    "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/on4wqkte_WhatsApp%20Image%202026-02-19%20at%2008.12.51.jpeg",
    "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/l3jpyj9d_WhatsApp%20Image%202026-02-19%20at%2008.12.55.jpeg",
    "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/xr5oy31y_WhatsApp%20Image%202026-02-19%20at%2008.12.54.jpeg"
  ]
};

// Services data
const SERVICES = [
  { icon: Car, title: "Guincho para Carros", description: "Remoção rápida e segura para veículos leves." },
  { icon: Bike, title: "Guincho para Motos", description: "Transporte seguro de motos e scooters." },
  { icon: Truck, title: "Guincho para Caminhões", description: "Atendimento especializado para caminhões." },
  { icon: Fuel, title: "Pane Seca", description: "Entrega de combustível ou remoção." },
  { icon: Wrench, title: "Pane Mecânica", description: "Remoção imediata em caso de falhas." },
  { icon: Battery, title: "Pane Elétrica", description: "Leve seu veículo até a oficina." },
  { icon: CircleDot, title: "Troca de Pneu", description: "Auxílio ou remoção." },
  { icon: Shield, title: "Socorro Rodoviário", description: "Atendimento rápido em rodovias." }
];

// Navbar Component
const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const menuItems = [
    { label: "Home", href: "#home" },
    { label: "Sobre Nós", href: "#sobre" },
    { label: "Serviços", href: "#servicos" },
    { label: "Clientes", href: "#clientes" },
    { label: "Parceiros", href: "#parceiros" },
    { label: "Contato", href: "#contato" }
  ];

  const scrollToSection = (href) => {
    setIsMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav 
      data-testid="navbar"
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled ? "navbar-solid" : "navbar-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a 
            href="#home" 
            onClick={(e) => { e.preventDefault(); scrollToSection("#home"); }}
            className="flex items-center gap-3"
            data-testid="logo"
          >
            <Truck className="h-8 w-8 text-[#D40000]" />
            <span className="font-bold text-xl md:text-2xl text-white uppercase tracking-tight" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
              {BUSINESS.name}
            </span>
          </a>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            {menuItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); scrollToSection(item.href); }}
                className="text-white hover:text-[#D40000] transition-colors font-medium text-sm uppercase tracking-wider"
                data-testid={`nav-${item.label.toLowerCase().replace(" ", "-")}`}
              >
                {item.label}
              </a>
            ))}
            <a
              href={`tel:${BUSINESS.whatsappNumber}`}
              className="flex items-center gap-2 bg-[#D40000] text-white px-4 py-2 rounded-md font-semibold hover:bg-[#B30000] transition-colors"
              data-testid="nav-phone-button"
            >
              <Phone className="h-4 w-4" />
              <span className="hidden lg:inline">{BUSINESS.whatsapp}</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white p-2"
            data-testid="mobile-menu-button"
            aria-label="Menu"
          >
            {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div 
          className="md:hidden bg-black/95 backdrop-blur-md"
          data-testid="mobile-menu"
        >
          <div className="px-4 py-6 space-y-4">
            {menuItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); scrollToSection(item.href); }}
                className="block text-white hover:text-[#D40000] transition-colors font-medium text-lg uppercase tracking-wider py-2"
                data-testid={`mobile-nav-${item.label.toLowerCase().replace(" ", "-")}`}
              >
                {item.label}
              </a>
            ))}
            <a
              href={`tel:${BUSINESS.whatsappNumber}`}
              className="flex items-center justify-center gap-2 bg-[#D40000] text-white px-4 py-3 rounded-md font-semibold w-full mt-4"
              data-testid="mobile-phone-button"
            >
              <Phone className="h-5 w-5" />
              {BUSINESS.whatsapp}
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

// Hero Section
const HeroSection = () => {
  const openWhatsApp = () => {
    const message = encodeURIComponent("Olá! Preciso de um guincho. Pode me ajudar?");
    window.open(`https://wa.me/${BUSINESS.whatsappNumber}?text=${message}`, "_blank");
  };

  return (
    <section 
      id="home" 
      className="hero-section"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div 
        className="hero-bg"
        style={{ backgroundImage: `url(${IMAGES.hero})` }}
      />
      {/* Overlay */}
      <div className="absolute inset-0 hero-overlay" />
      
      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <h1 
          className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white uppercase tracking-tight mb-6 animate-fade-in-up"
          style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
          data-testid="hero-title"
        >
          Guincho 24h em Sorocaba
          <span className="block text-[#D40000]">Atendimento Imediato</span>
        </h1>
        <p 
          className="text-lg md:text-xl text-gray-200 mb-8 animate-fade-in-up animation-delay-200"
          data-testid="hero-subtitle"
        >
          Socorro rápido, seguro e profissional.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up animation-delay-400">
          <Button
            onClick={openWhatsApp}
            className="btn-primary text-lg px-8 py-6"
            data-testid="hero-cta-button"
          >
            <MessageCircle className="h-5 w-5" />
            Chamar Guincho Agora
          </Button>
          <a
            href={`tel:${BUSINESS.whatsappNumber}`}
            className="flex items-center gap-2 text-white hover:text-[#D40000] transition-colors text-lg font-medium"
            data-testid="hero-phone-link"
          >
            <Phone className="h-5 w-5" />
            {BUSINESS.whatsapp}
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <ChevronRight className="h-8 w-8 text-white rotate-90" />
      </div>
    </section>
  );
};

// About Section
const AboutSection = () => {
  return (
    <section 
      id="sobre" 
      className="py-16 md:py-24 bg-white"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="order-2 lg:order-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="h-1 w-12 bg-[#D40000]" />
              <span className="text-[#D40000] font-semibold uppercase tracking-wider text-sm">Quem Somos</span>
            </div>
            <h2 
              className="section-title text-3xl md:text-5xl text-black mb-6"
              data-testid="about-title"
            >
              Sobre Nós
            </h2>
            <p 
              className="text-gray-600 text-lg leading-relaxed mb-6"
              data-testid="about-text"
            >
              Somos o <strong className="text-black">Guincho Xavier</strong>, atuando com atendimento rápido, seguro e responsável em Sorocaba e toda a região. Trabalhamos 24 horas para ajudar motoristas em situações de emergência, oferecendo guincho leve e pesado, remoção de veículos, pane seca, pane elétrica, pane mecânica e socorro rodoviário.
            </p>
            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              Nosso foco é simples: <strong className="text-black">chegar rápido, resolver o problema e entregar segurança para quem precisa.</strong>
            </p>
            <div className="flex flex-wrap gap-6">
              <div className="flex items-center gap-3">
                <div className="bg-[#D40000]/10 p-3 rounded-lg">
                  <Clock className="h-6 w-6 text-[#D40000]" />
                </div>
                <div>
                  <p className="font-bold text-black">24 Horas</p>
                  <p className="text-gray-500 text-sm">Atendimento</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="bg-[#D40000]/10 p-3 rounded-lg">
                  <MapPin className="h-6 w-6 text-[#D40000]" />
                </div>
                <div>
                  <p className="font-bold text-black">Sorocaba</p>
                  <p className="text-gray-500 text-sm">e Região</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="bg-[#D40000]/10 p-3 rounded-lg">
                  <Shield className="h-6 w-6 text-[#D40000]" />
                </div>
                <div>
                  <p className="font-bold text-black">Segurança</p>
                  <p className="text-gray-500 text-sm">Garantida</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Image */}
          <div className="order-1 lg:order-2">
            <div className="relative">
              <img
                src={IMAGES.about}
                alt="Guincho Xavier em ação"
                className="rounded-2xl shadow-2xl w-full h-[400px] lg:h-[500px] object-cover"
                data-testid="about-image"
              />
              <div className="absolute -bottom-6 -left-6 bg-[#D40000] text-white p-6 rounded-xl shadow-lg hidden md:block">
                <p className="text-4xl font-bold" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>24h</p>
                <p className="text-sm uppercase tracking-wider">Disponível</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Services Section
const ServicesSection = () => {
  return (
    <section 
      id="servicos" 
      className="py-16 md:py-24 bg-[#F4F4F4]"
      data-testid="services-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-1 w-12 bg-[#D40000]" />
            <span className="text-[#D40000] font-semibold uppercase tracking-wider text-sm">O Que Fazemos</span>
            <div className="h-1 w-12 bg-[#D40000]" />
          </div>
          <h2 
            className="section-title text-3xl md:text-5xl text-black"
            data-testid="services-title"
          >
            Nossos Serviços
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICES.map((service, index) => (
            <Card 
              key={index} 
              className="service-card bg-white border-0 shadow-sm hover:shadow-lg"
              data-testid={`service-card-${index}`}
            >
              <CardContent className="p-6 text-center">
                <div className="service-icon bg-gray-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <service.icon className="h-8 w-8 text-[#D40000]" />
                </div>
                <h3 className="font-bold text-lg text-black mb-2 uppercase" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
                  {service.title}
                </h3>
                <p className="text-gray-600 text-sm">
                  {service.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

// Clients/Gallery Section with Carousel
const ClientsSection = () => {
  return (
    <section 
      id="clientes" 
      className="py-16 md:py-24 bg-white"
      data-testid="clients-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-1 w-12 bg-[#D40000]" />
            <span className="text-[#D40000] font-semibold uppercase tracking-wider text-sm">Portfólio</span>
            <div className="h-1 w-12 bg-[#D40000]" />
          </div>
          <h2 
            className="section-title text-3xl md:text-5xl text-black mb-4"
            data-testid="clients-title"
          >
            Nossos Trabalhos Recentes
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Cada atendimento é feito com cuidado, segurança e responsabilidade.
          </p>
        </div>

        {/* Gallery Carousel */}
        <div className="relative px-12">
          <Carousel
            opts={{
              align: "start",
              loop: true,
              dragFree: true,
            }}
            className="w-full"
            data-testid="gallery-carousel"
          >
            <CarouselContent className="-ml-4">
              {IMAGES.gallery.map((image, index) => (
                <CarouselItem 
                  key={index} 
                  className="pl-4 basis-1/2 md:basis-1/2 lg:basis-1/3"
                  data-testid={`gallery-item-${index}`}
                >
                  <div className="group relative overflow-hidden rounded-xl shadow-md hover:shadow-xl transition-all duration-300">
                    <img
                      src={image}
                      alt={`Atendimento Guincho Xavier ${index + 1}`}
                      className="w-full h-56 md:h-64 lg:h-72 object-cover transform group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    {/* Caption overlay - always visible */}
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-4">
                      <p className="text-white text-center text-sm font-medium">
                        Atendimento realizado pelo Guincho Xavier
                      </p>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            
            {/* Custom Navigation Arrows */}
            <CarouselPrevious 
              className="absolute -left-2 md:left-0 top-1/2 -translate-y-1/2 h-10 w-10 md:h-12 md:w-12 bg-[#D40000] hover:bg-[#B30000] text-white border-0 shadow-lg"
              data-testid="carousel-prev"
            />
            <CarouselNext 
              className="absolute -right-2 md:right-0 top-1/2 -translate-y-1/2 h-10 w-10 md:h-12 md:w-12 bg-[#D40000] hover:bg-[#B30000] text-white border-0 shadow-lg"
              data-testid="carousel-next"
            />
          </Carousel>
        </div>
      </div>
    </section>
  );
};

// Partners Section
const PartnersSection = () => {
  // Partner logos - real insurance company logos
  const partnerLogos = [
    { name: "Zurich Seguros", logo: "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/unlxez67_zurich%20seguros.png" },
    { name: "Banco do Brasil", logo: "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/5fgcebwn_Banco%20do%20brasil.png" },
    { name: "Tokio Marine", logo: "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/jzjodmqn_tokio%20marine.png" },
    { name: "Allianz", logo: "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/s4bzuwfp_allianz.png" },
    { name: "Mapfre Seguros", logo: "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/a4g8ollz_mapefre.png" },
    { name: "Sem Parar", logo: "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/l106zyac_sem%20parare.png" },
    { name: "Unidas", logo: "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/35jg42te_unidas.png" },
    { name: "Movida", logo: "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/9fat7hr8_logo-movida-1024.png" },
    { name: "Sompo Seguros", logo: "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/99jrw9ic_sompo%20seguros.png" },
    { name: "Localiza", logo: "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/tjxcfh9l_localiza.png" },
    { name: "Suhai Seguradora", logo: "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/au26w1hi_suhai.png" },
    { name: "HDI Seguros", logo: "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/po9geckb_hdi.png" },
    { name: "Liberty Seguros", logo: "https://customer-assets.emergentagent.com/job_auto-socorro-sp/artifacts/42m1uf8m_liberty%20seguros.png" }
  ];

  return (
    <section 
      id="parceiros" 
      className="py-16 md:py-24 bg-[#F4F4F4]"
      data-testid="partners-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-1 w-12 bg-[#D40000]" />
            <span className="text-[#D40000] font-semibold uppercase tracking-wider text-sm">Confiança</span>
            <div className="h-1 w-12 bg-[#D40000]" />
          </div>
          <h2 
            className="section-title text-3xl md:text-5xl text-black mb-4"
            data-testid="partners-title"
          >
            Nossos Parceiros
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Trabalhamos com seguradoras que confiam em nosso atendimento rápido e seguro. 
            Essas parcerias reforçam nosso compromisso com qualidade, responsabilidade e segurança.
          </p>
        </div>

        {/* Partners Logo Grid */}
        <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 md:gap-8 items-center justify-items-center">
            {partnerLogos.map((partner, index) => (
              <div 
                key={index}
                className="flex items-center justify-center p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-all hover:shadow-md group w-full"
                data-testid={`partner-logo-${index}`}
              >
                <div className="w-full h-20 md:h-24 flex items-center justify-center">
                  <img 
                    src={partner.logo} 
                    alt={partner.name}
                    className="max-h-full max-w-full object-contain filter grayscale hover:grayscale-0 transition-all duration-300"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Caption */}
        <p 
          className="text-center text-gray-500 mt-8 text-sm font-medium"
          data-testid="partners-caption"
        >
          Seguradoras que confiam no Guincho Xavier.
        </p>
      </div>
    </section>
  );
};

// Contact Section
const ContactSection = () => {
  const [formData, setFormData] = useState({
    nome: "",
    origem: "",
    destino: "",
    modelo: "",
    mensagem: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const message = `*Pedido de Guincho*%0A%0A*Nome:* ${formData.nome}%0A*Origem:* ${formData.origem}%0A*Destino:* ${formData.destino}%0A*Modelo do Veículo:* ${formData.modelo}%0A*Mensagem:* ${formData.mensagem}`;
    window.open(`https://wa.me/${BUSINESS.whatsappNumber}?text=${message}`, "_blank");
  };

  return (
    <section 
      id="contato" 
      className="py-16 md:py-24 bg-[#F4F4F4]"
      data-testid="contact-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-1 w-12 bg-[#D40000]" />
            <span className="text-[#D40000] font-semibold uppercase tracking-wider text-sm">Fale Conosco</span>
            <div className="h-1 w-12 bg-[#D40000]" />
          </div>
          <h2 
            className="section-title text-3xl md:text-5xl text-black mb-4"
            data-testid="contact-title"
          >
            Contato
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Form */}
          <div className="bg-white p-8 rounded-2xl shadow-lg">
            <form onSubmit={handleSubmit} className="space-y-5" data-testid="contact-form">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Nome</label>
                <Input
                  type="text"
                  name="nome"
                  value={formData.nome}
                  onChange={handleChange}
                  placeholder="Seu nome completo"
                  className="form-input w-full"
                  required
                  data-testid="form-nome"
                />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Origem</label>
                  <Input
                    type="text"
                    name="origem"
                    value={formData.origem}
                    onChange={handleChange}
                    placeholder="Endereço de origem"
                    className="form-input w-full"
                    required
                    data-testid="form-origem"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Destino</label>
                  <Input
                    type="text"
                    name="destino"
                    value={formData.destino}
                    onChange={handleChange}
                    placeholder="Endereço de destino"
                    className="form-input w-full"
                    required
                    data-testid="form-destino"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Modelo do Veículo</label>
                <Input
                  type="text"
                  name="modelo"
                  value={formData.modelo}
                  onChange={handleChange}
                  placeholder="Ex: Honda Civic 2020"
                  className="form-input w-full"
                  required
                  data-testid="form-modelo"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Mensagem</label>
                <Textarea
                  name="mensagem"
                  value={formData.mensagem}
                  onChange={handleChange}
                  placeholder="Descreva sua situação..."
                  className="form-input form-textarea w-full"
                  rows={4}
                  data-testid="form-mensagem"
                />
              </div>
              <Button
                type="submit"
                className="btn-primary w-full text-lg py-6"
                data-testid="form-submit-button"
              >
                <Send className="h-5 w-5" />
                Enviar Pedido de Guincho
              </Button>
            </form>

            {/* Contact Info */}
            <div className="mt-8 pt-8 border-t border-gray-200">
              <div className="flex flex-col sm:flex-row gap-6">
                <a
                  href={`https://wa.me/${BUSINESS.whatsappNumber}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-gray-700 hover:text-[#25D366] transition-colors"
                  data-testid="contact-whatsapp-link"
                >
                  <div className="bg-[#25D366]/10 p-3 rounded-lg">
                    <MessageCircle className="h-6 w-6 text-[#25D366]" />
                  </div>
                  <div>
                    <p className="font-semibold">WhatsApp</p>
                    <p className="text-sm">{BUSINESS.whatsapp}</p>
                  </div>
                </a>
                <a
                  href={`tel:${BUSINESS.whatsappNumber}`}
                  className="flex items-center gap-3 text-gray-700 hover:text-[#D40000] transition-colors"
                  data-testid="contact-phone-link"
                >
                  <div className="bg-[#D40000]/10 p-3 rounded-lg">
                    <Phone className="h-6 w-6 text-[#D40000]" />
                  </div>
                  <div>
                    <p className="font-semibold">Telefone</p>
                    <p className="text-sm">{BUSINESS.whatsapp}</p>
                  </div>
                </a>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="map-container h-[400px] lg:h-full min-h-[400px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d117003.25999424456!2d-47.52893695!3d-23.4863746!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c58a9a9a5e5e5f%3A0x9f8b5b5a5a5a5a5a!2sSorocaba%2C%20SP!5e0!3m2!1spt-BR!2sbr!4v1625000000000!5m2!1spt-BR!2sbr"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização Guincho Xavier - Sorocaba"
              data-testid="contact-map"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

// Footer Section
const Footer = () => {
  return (
    <footer 
      className="footer noise-bg py-12"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          {/* Logo & Name */}
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-3 mb-3">
              <Truck className="h-8 w-8 text-[#D40000]" />
              <span className="font-bold text-2xl text-white uppercase tracking-tight" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
                {BUSINESS.name}
              </span>
            </div>
            <p className="text-gray-400">{BUSINESS.tagline}</p>
          </div>

          {/* Contact Info */}
          <div className="text-center">
            <p className="text-white font-semibold mb-2">WhatsApp</p>
            <a
              href={`https://wa.me/${BUSINESS.whatsappNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#D40000] hover:text-white transition-colors text-lg font-medium"
              data-testid="footer-whatsapp"
            >
              {BUSINESS.whatsapp}
            </a>
            <p className="text-gray-400 mt-2">{BUSINESS.location}</p>
          </div>

          {/* Institutional Text */}
          <div className="text-center md:text-right">
            <p className="text-gray-400 text-sm">
              Atendimento rápido, seguro e responsável em Sorocaba e região.
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <p className="text-center text-gray-500 text-sm">
            © {new Date().getFullYear()} {BUSINESS.name}. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

// WhatsApp Floating Button
const WhatsAppFloat = () => {
  const openWhatsApp = () => {
    const message = encodeURIComponent("Olá! Preciso de um guincho. Pode me ajudar?");
    window.open(`https://wa.me/${BUSINESS.whatsappNumber}?text=${message}`, "_blank");
  };

  return (
    <button
      onClick={openWhatsApp}
      className="whatsapp-float animate-bounce-slow"
      aria-label="Chamar no WhatsApp"
      data-testid="whatsapp-float-button"
    >
      <MessageCircle className="h-7 w-7" />
    </button>
  );
};

// Main App Component
function App() {
  return (
    <div className="App">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <ClientsSection />
      <PartnersSection />
      <ContactSection />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
